import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { X, FileSpreadsheet, Loader2, CheckCircle2 } from "lucide-react";

export default function TurnosDialog({ open, opId, onClose, onDone }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);

  if (!open) return null;

  const upload = async () => {
    if (!file) return;
    setUploading(true);
    setResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await api.post(`/operadores/${opId}/import/turnos`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(res.data.resumen);
      toast.success("Turnos importados correctamente");
      onDone && onDone();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="turnos-dialog">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 w-full max-w-md rounded-lg bg-background shadow-xl border">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h3 className="text-lg font-semibold text-slate-900" style={{ fontFamily: "Work Sans" }}>Importar Turnos</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700"><X size={20} /></button>
        </div>

        <div className="px-6 py-5">
          <p className="text-sm text-muted-foreground mb-4">
            Sube el fichero <span className="font-mono text-xs bg-slate-100 px-1 rounded">Turnos .xlsx</span>. Se
            importarán automáticamente las hojas <b>CALENDARIOS</b> y <b>TURNOS</b> (las horas y fechas se normalizan).
          </p>

          <label className="flex flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-border bg-slate-50 px-4 py-8 cursor-pointer hover:border-primary transition-colors" data-testid="turnos-dropzone">
            <FileSpreadsheet className="text-primary" size={28} />
            <span className="text-sm text-slate-600">{file ? file.name : "Selecciona un archivo .xlsx"}</span>
            <input
              type="file"
              accept=".xlsx"
              className="hidden"
              data-testid="turnos-file-input"
              onChange={(e) => { setFile(e.target.files[0]); setResult(null); }}
            />
          </label>

          {result && (
            <div className="mt-4 rounded-md bg-emerald-50 border border-emerald-200 p-3 text-sm text-emerald-800" data-testid="turnos-result">
              <div className="flex items-center gap-2 font-medium mb-1"><CheckCircle2 size={16} /> Importación completada</div>
              <ul className="ml-6 list-disc">
                <li>Calendarios: {result.calendarios}</li>
                <li>Turnos: {result.turnos}</li>
              </ul>
            </div>
          )}
        </div>

        <div className="flex items-center justify-end gap-2 px-6 py-4 border-t">
          <button onClick={onClose} className="inline-flex items-center rounded-md border border-border bg-card h-9 px-4 text-sm font-medium hover:bg-slate-50">Cerrar</button>
          <button
            onClick={upload}
            disabled={!file || uploading}
            data-testid="turnos-upload-btn"
            className="inline-flex items-center gap-2 rounded-md bg-primary text-primary-foreground h-9 px-4 text-sm font-medium shadow-sm hover:bg-primary/90 disabled:opacity-50"
          >
            {uploading && <Loader2 size={16} className="animate-spin" />}
            Importar
          </button>
        </div>
      </div>
    </div>
  );
}
